import axios from '../http/api'
// import md5 from 'js-md5';
import config from '../util/config.js';
import qs from 'qs'
import { isDisableTrackM } from '../util/experiment';

function isSupportWebp() {
  try {
    return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0 ? 1 : 0;
  } catch(err) {
    return 0;
  }
}

function objKeySort(arys) {
  const newkey = Object.keys(arys).sort();
  let newObj = {};
  for (let i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = arys[newkey[i]];
  }
  return newObj;
}

function paramsProcess(params = null) {
  const timestamp = new Date().getTime();
  const tmp = JSON.parse(String(timestamp).substr(0, 10));
  return {
    request_time: tmp,
    ...params
  };
}

export function getQueryVariable(variable) {
  let query = '';
  try {
    query = decodeURIComponent(window.location.search.substring(1)).replace(/&amp;/g, '&');
  } catch (e) {
    query = window.location.search.substring(1).replace(/&amp;/g, '&');
  }
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return '';
}

export function getCookie(variable) {
  let cookie = document.cookie;
  const vars = cookie.split(";").map(item => item.trim());
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] === variable) {
      return pair[1];
    }
  }
  return '';
}

/**
 * atm模板订单提交格式转换
 */
function atmFormat(params) {
  // 香港，日本，阿联酋，沙特atm地区为三级，其他为二级
  const areaDetail = cConf.autoFillProvince ?
    {
      province: cConf.autoFillProvince,
      city: params.state,
      area: params.city,
    } : {
      province: params.state,
      city: params.city,
      area: params.street,
    }

    // let krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/', 'https://www.cheapct.top/'];
  let krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/'];

  if (krips.includes(location.origin + '/')) {
    // if (sessionStorage.cl === 'kr_kr') {
      return {
        user_info: {
          name: params.uname,
          phone: params.phone,
          email: params.email,
          postal: params.postal,
          address: params.address,
          id_card: params.id_card,
          ...areaDetail
        },
        user_note: params.guest,
        item_info: {
          combo_id: params.combo_id,
          final_price: params.total_price,
          count: 1,
          prostr: params.package
        },
        utm: {
          utm_source: getQueryVariable('utm_source'),
          u: getQueryVariable('u'),
          source: source
        },
        site_info: {
          // 本地地址处理和测试地址处理
          domain: location.host === 'localhost' ? 'www.tw51buygobuy.com' : location.host.replace('w3', 'www'),
          site_name: getQueryVariable('path'),
          item_hash: getQueryVariable('id'),
          cl: sessionStorage.cl
        },
        payment_info: {
          payment_method: 'PingPongCheckout'
        }
      };
    } else {
      return {
        user_info: {
          name: params.uname,
          phone: params.phone,
          email: params.email,
          postal: params.postal,
          address: params.address,
          id_card: params.id_card,
          ...areaDetail
        },
        user_note: params.guest,
        item_info: {
          combo_id: params.combo_id,
          final_price: params.total_price,
          count: 1,
          prostr: params.package
        },
        utm: {
          utm_source: getQueryVariable('utm_source'),
          u: getQueryVariable('u'),
          source: source
        },
        site_info: {
          // 本地地址处理和测试地址处理
          domain: location.host === 'localhost' ? 'www.tw51buygobuy.com' : location.host.replace('w3', 'www'),
          site_name: getQueryVariable('path'),
          item_hash: getQueryVariable('id'),
          cl: sessionStorage.cl
        },
      };
    }
}

function encodeForCloudFront(str) {
  return encodeURIComponent(str.normalize('NFD'));
}

/**
 * 语言模板信息
 * 每次更新json需要修改query参数v的值
 * @returns {AxiosPromise}
 */
export function langInfo(type = sessionStorage.cl) {
  return axios.get(`${process.env.STATIC_CDN}/static/language/${type}.json?v=1.5.2`)
}

export function getOnlineStatus(orderSn) {
  return axios.get(`${config.hostUrl}/cody/order/get?orderSn=${orderSn}`)
}

/**
 * 获取地址和邮编json
 * 每次更新json需要修改query参数v的值
 * @returns {AxiosPromise}
 */
export function getZipcode(type = sessionStorage.cl) {
  if (sessionStorage.getItem("configData") && JSON.parse(sessionStorage.getItem("configData")).zipcodeType) {
    type = JSON.parse(sessionStorage.getItem("configData")).zipcodeType;
  }
  return axios.get(`${process.env.STATIC_CDN}/static/zipcode/${encodeForCloudFront(type)}.json?v=1.4.9`)
}
export function getZipcodeChild(child = '', type = sessionStorage.cl) {
  if (sessionStorage.getItem("configData") && JSON.parse(sessionStorage.getItem("configData")).zipcodeType) {
    type = JSON.parse(sessionStorage.getItem("configData")).zipcodeType;
  }
  return axios.get(`${process.env.STATIC_CDN}/static/zipcode/${type}/${encodeForCloudFront(child)}.json?v=1.4.9`)
}

/**
 * 用户需知信息
 * 每次更新json需要修改query参数v的值
 * @returns {AxiosPromise}
 */
export function getSupply(type = sessionStorage.cl) {
  return axios.get(`${process.env.STATIC_CDN}/static/supply/${type}.json?v=1.3.6`)
}

export function getFaq(type = sessionStorage.cl) {
  return axios.get(`${process.env.STATIC_CDN}/static/faq/${type}.json?v=1.3.8`)
}

export function getPrivacyPolicy(type = sessionStorage.cl) {
  let hostname = window.location.hostname;
  if (hostname === 'www.cheapct.top'){
    return axios.get(`${process.env.STATIC_CDN}/static/privacyPolicy/${type}_pay.json?v=1.3.9`)
  }else {
    return axios.get(`${process.env.STATIC_CDN}/static/privacyPolicy/${type}.json?v=1.3.7`)
  }
}

export function getReturnPolicy(type = sessionStorage.cl) {
  return axios.get(`${process.env.STATIC_CDN}/static/returnPolicy/${type}.json?v=1.3.8`)
}

export function getShippingPolicy(type = sessionStorage.cl) {
  return axios.get(`${process.env.STATIC_CDN}/static/shippingPolicy/${type}.json?v=1.3.8`)
}


/**
 * 公共信息
 * @returns {AxiosPromise}
 * @public 刷新配置缓存接口：/codx/reload_config
 */
export function getConfig() {
  const data = {
    item: getQueryVariable('id'),
    path: getQueryVariable('path'),
    cl: sessionStorage.cl
  };
  return axios.get(`${config.hostUrl}/codx${isAtm ? '/ab' : ''}/item/config`, {params: data, loading: true})
}

/**
 * 商品详情
 * @returns {AxiosPromise}
 */
export function shopDetail(params) {
  const data = paramsProcess({'is_support_webp': isSupportWebp(), ...params});
  return axios.get(`${config.hostUrl}/codx${isAtm ? '/ab' : ''}/item/detail`, {params: data, loading: true})
}

/**
 * 下订单
 * @returns {AxiosPromise}
 */
export function shopCreate(params, eventId, msg) {
  let newParams = paramsProcess(params);
  newParams.pit_c_k = getQueryVariable('u');
  if (msg === 'confirm') {
    newParams.guest += '（用户确认更新订单）'
  }
  if (cConf.thAddress) {
    newParams.address = newParams.town + newParams.address;
  }
  if (newParams.address2) {
    newParams.address = newParams.address + ",门牌号:" + newParams.address2
  }
  let data;
  if (isAtm) {
    data = atmFormat(newParams);
  } else {
    data = qs.stringify(newParams);
  }
  // let krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/', 'https://www.cheapct.top/'];
  let krips = ['https://kr.shop.cartx.cloud/', 'https://www.vintagena.top/', 'https://it.shop.cartx.cloud/'];

  if (krips.includes(location.origin + '/')) {
  // if (sessionStorage.cl === 'kr_kr') {
    // todo 域名改为config.hostUrl
    return axios.post(`${config.hostUrl}/cody/order/placed`, data, {
      headers: {
        'Content-Type': isAtm ? 'application/json' : 'application/x-www-form-urlencoded',
        'eventId': eventId,
        'pixelId': fb_id || '352985638959852'
      },
      loading: true
    })
  } else {
    return axios.post(`${config.hostUrl}/codx${isAtm ? '/ab' : ''}/order/confirm${isAtm ? '' : '2'}`, data, {
      headers: {
        'Content-Type': isAtm ? 'application/json' : 'application/x-www-form-urlencoded',
        'eventId': eventId,
        'pixelId': fb_id || '352985638959852'
      },
      loading: true
    })
  }
}

/**
 * 订单查询
 * @returns {AxiosPromise}
 */
export function search(params) {
  const data = paramsProcess(params);
  return axios.get(`${config.hostUrl}/codx${isAtm ? '/ab' : ''}/order/query`, {
    params: data,
    loading: true
    // headers: {
    //   'sys-site-sn': md5(md5(JSON.stringify(objKeySort(data)) + "Ino9LhvD52FxPcSbt4WyH3zdkCXN7agE")),
    //   'sys-site-path':sessionStorage.cl
    // }
  })
}

/**
 * 活动页面
 * @param params
 * @return {AxiosPromise}
 */
export function promotion(params) {
  return axios.get(`${config.hostUrl}/codx/shopify/promotion`, {
    params,
    loading: true
  })
}

/**
 * 首页
 * @param params
 * @return {AxiosPromise}
 */
export function getHomeItem(params) {
  return axios.get(`${config.hostUrl}/codx/home?configName=默认配置`, {
    params,
    loading: false
  })
}

/**
 * 首页
 * @param params
 * @return {AxiosPromise}
 */
export function getConfigInfo(domain) {
  // 域名集合，google域名访问链接为页面url（tower：）
  let ggDomains = ['recommenddaily.top','studentmo.top','trendnewlife.top','felicityman.top','yousuperbcool.top','stayvogue.top','sportwoek.top','tihappy.top','premiummo.top','happylo.top','stopresearch.top','conhappy.top','stoppartners.top','stopconnect.top','fashionedclothing.com','indianhappy.top','fahappy.top','vahappy.top','gehappy.top','rohappy.top','spstop.top','mpstop.top','bohappy.top','moology.top','chstop.top','lkwear.top','sydirectory.top','qualitysy.top','californiasy.top','easyoy.top','syresources.top','ladysy.top','chicystore.com','yinghapp.com','drwor.top','manlk.top','namecr.top','rockcr.top','trafficen.top','tlline.top','citytl.top','domainox.top','shoplifego.com','romanticorner.com','greetedshop.com','gracetiro.com','pitting.top','lackbag.com','colorfulskirt.com','indiansb.top','freedomle.top','leeye.top','beachle.top','lefriends.top','minisb.top','goldensb.top','sbsale.top','familysb.top','energysb.top','ultimatesb.top','geosb.top','bodysb.top','safesb.top','crazysb.top','worksb.top','zensb.top','crazysb.top','girlct.top','cherishes.top','shop.sboutique.top',
    'www.recommenddaily.top','www.studentmo.top','www.trendnewlife.top','www.felicityman.top','www.yousuperbcool.top','www.stayvogue.top','www.sportwoek.top','www.tihappy.top','www.premiummo.top','www.happylo.top','www.stopresearch.top','www.conhappy.top','www.stoppartners.top','www.stopconnect.top','www.fashionedclothing.com','www.indianhappy.top','www.fahappy.top','www.vahappy.top','www.gehappy.top','www.rohappy.top','www.spstop.top','www.mpstop.top','www.bohappy.top','www.moology.top','www.chstop.top','www.lkwear.top','www.sydirectory.top','www.qualitysy.top','www.californiasy.top','www.easyoy.top','www.syresources.top','www.ladysy.top','www.chicystore.com','www.yinghapp.com','www.drwor.top','www.manlk.top','www.namecr.top','www.rockcr.top','www.trafficen.top','www.tlline.top','www.citytl.top','www.domainox.top','www.shoplifego.com','www.romanticorner.com','www.greetedshop.com','www.gracetiro.com','www.pitting.top','www.lackbag.com','www.colorfulskirt.com','qymagazine.top','assigning.top','www.qymagazine.top','www.assigning.top','www.indiansb.top','www.freedomle.top','www.leeye.top','www.beachle.top','www.lefriends.top','www.minisb.top','www.goldensb.top','www.sbsale.top','www.familysb.top','www.energysb.top','www.ultimatesb.top','www.geosb.top','www.bodysb.top','www.safesb.top','www.crazysb.top','www.worksb.top','www.zensb.top','www.crazysb.top',
    'www.shinne.top','www.fashionles.top','www.nosycloth.top','www.josclub.top','www.oldstore.top','www.greetshop.top','www.girlct.top','www.cherishes.top','www.shop.sboutique.top'
  ];
  let url = `/api/getConfigByDomain?domain=${domain.domain}`
  if (ggDomains.indexOf(domain.domain) >= 0){
    url = `${config.hostUrl}` + url
  }else {
    url = "https://da.cartgo.cloud" + url
  }
  return axios.get(url, {
  // return axios.get(`https://da.cartgo.cloud/api/getConfigByDomain?domain=${domain.domain}`, {
  // return axios.get(`${config.hostUrl}/api/getConfigByDomain?domain=${domain.domain}`, {
    loading: false
  })
}

/**
 * 获取推荐列表
 * @param params
 * @return {AxiosPromise}
 */
export function getRecommendProducts(params) {
  return axios.get(`https://open.cartx.ai/api/out/recommend/products`, {
    params,
    loading: false
  })
}

export function commonApi(path, params) {
  return axios.post(`https://da.cartgo.cloud${path}`, params);
}


/**
 * 埋点
 * @returns
 */
export function mallSubmit(params) {
  if (isDisableTrackM()) {
    return;
  }

  let mallUrl = "/m"

  const data = {
    ...params,
    time_stamp: Date.now(),
    cl: sessionStorage.cl,
    user_ID: document.cookie ? getCookie('USERKEY') : '',
    UA: navigator.userAgent,
    campaign_ID: getQueryVariable('u'),
    experiment: document.cookie ? getCookie('STRATEGYKEY') : '',
    session_ID: sessionStorage.sessionId,
    utm_source: getQueryVariable('utm_source'),
    utm_medium: getQueryVariable('utm_medium'),
    ad_id: getQueryVariable('aid'),
    url: window.location.href,
  };
  return axios.get(mallUrl, {params: data})
}


export function errorCatch(params) {
  return axios.get(`static/error`, {
    params,
    loading: false
  })
}




// WEBPACK FOOTER //
// ./src/api/permission.js